<template>
  <div
    class="admin-page"
    @click="checkClick($event)"
  >
    <Transition>
      <JobModal
        v-if="selectedJob"
        :job="selectedJob"
        @close="selectedJob = false"
      />
    </Transition>
    <div class="admin-page-inner">
      <div class="admin-page-header">
        <div>
          <h1 class="admin-page-title">Nutzerverwaltung</h1>
        </div>
      </div>
      <section class="admin-panel mb-5">
        <div class="admin-panel__body text-left">
          <span class="block text-2xl font-bold">Neuen Benutzer anlegen</span>
          <div class="inline-block p-2 relative align-top">
            <span class="block font-bold mt-2">Benutzer</span>
            <input
              v-model="editedUser.displayName"
              placeholder="Mitarbeiternr"
              @click="filterUsers(editedUser)"
              @focus="filterUsers(editedUser)"
              @input="filterUsers(editedUser)"
              class="border-b-2 w-64 p-2 border-gray-500"
            />
            <div
              v-if="showUserDropdown == editedUser"
              ref="userDropdown"
              class="z-10 border-gray-500 absolute p-2 w-full bg-white max-h-96 overflow-y-auto"
            ></div>
          </div>
          <div class="inline-block p-2 relative">
            <span class="block font-bold mt-2">Berechtigungen</span>
            <input
              type="checkbox"
              v-model="editedUser.superadmin"
              id="editedUser_superadmin"
              @change="sanitizePermissions(editedUser, 'superadmin')"
            />
            <label for="editedUser_superadmin">Superadmin</label><br />
            <input
              type="checkbox"
              v-model="editedUser.admin"
              id="editedUser_admin"
              @change="sanitizePermissions(editedUser, 'admin')"
            />
            <label for="editedUser_admin">Admin</label><br />
            <input
              type="checkbox"
              v-model="editedUser.standby"
              id="editedUser_standby"
              @change="sanitizePermissions(editedUser, 'standby')"
            />
            <label for="editedUser_standby">Rufbereitschaft</label><br />
            <input
              type="checkbox"
              v-model="editedUser.internalDispo"
              id="editedUser_internalDispo"
              @change="
                sanitizePermissions(editedUser, 'internalDispo')
              "
            />
            <label for="editedUser_internalDispo">Interner Disponent</label
              ><br />
            <input
              type="checkbox"
              v-model="editedUser.externalDispo"
              id="editedUser_externalDispo"
              @change="
                sanitizePermissions(editedUser, 'externalDispo')
              "
            />
            <label for="editedUser_externalDispo">Externer Disponent</label>
            <br />
            <input
              type="checkbox"
              v-model="editedUser.documents"
              id="editedUser_documents"
              @change="
                sanitizePermissions(editedUser, 'documents')
              "
            />
            <label for="editedUser_documents">Schicht-Dokumente</label>
            <br />
            <input
              type="checkbox"
              v-model="editedUser.tours"
              id="editedUser_tours"
              @change="
                sanitizePermissions(editedUser, 'tours')
              "
            />
            <label for="editedUser_tours">Rundgänge</label>
            <br />
            <input
              type="checkbox"
              v-model="editedUser.editEmployees"
              id="editedUser_editEmployees"
              @change="
                sanitizePermissions(editedUser, 'editEmployees')
              "
            />
            <label for="editedUser_editEmployees">Mitarbeiterverwaltung</label>
            <br />
            <input
              type="checkbox"
              v-model="editedUser.sensitiveDocuments"
              id="editedUser_sensitiveDocuments"
              @change="
                sanitizePermissions(editedUser, 'sensitiveDocuments')
              "
            />
            <label for="editedUser_sensitiveDocuments">Vertrauliche Dokumente</label>
          </div>

          <div
            v-if="editedUser.internalDispo &&! editedUser.admin"
            class="inline-block p-2 relative align-top"
          >
            <span class="block font-bold mt-2">Projekt</span>
            <input
              v-model="editedUser.project"
              placeholder="Projektname"
              @click="filterProjects(editedUser, true)"
              @focus="filterProjects(editedUser, true)"
              class="border-b-2 w-full sm:w-96 p-2 border-gray-500"
              @input="filterProjects(editedUser, true)"
            />
            <div
              v-if="showProjectDropdown == editedUser"
              ref="projectDropdown"
              class="z-10 border-gray-500 absolute p-2 w-full bg-white max-h-96 overflow-y-auto"
            ></div>
          </div>
          <div
            v-if="editedUser.externalDispo &&! editedUser.admin"
            class="inline-block p-2 relative align-top"
          >
            <span class="block font-bold mt-2">Firma</span>
            <input
              v-model="editedUser.ca"
              placeholder="Firmenschlüssel"
              @click="filterCAs(editedUser, true)"
              @focus="filterCAs(editedUser, true)"
              class="border-b-2 w-36 p-2 border-gray-500"
              @input="filterCAs(editedUser, true)"
            />
            <div
              v-if="showCADropdown == editedUser"
              ref="caDropdown"
              class="z-10 border-gray-500 absolute p-2 w-full bg-white max-h-96 overflow-y-auto"
            ></div>
          </div>
          <button
            type="button"
            class="ml-4 mt-4 admin-button--primary"
            @click="changeUser(editedUser)"
          >
            Hinzufügen
          </button>
        </div>
      </section>
        <div v-if="advancedUsers.length > 0" id="tablecontent" class="w-full admin-panel p-4 overflow-x-auto">
          <table class="w-full overflow-x-auto block md:table">
            <thead>
              <th>Personalnummer</th>
              <th>Name</th>
              <th>Berechtigungen</th>
              <th>Projekt / Firmenkürzel</th>
              <th>Aktionen</th>
            </thead>
            <tbody>
              <tr v-for="user in advancedUsers" :key="user.persnr">
                <td>{{ user.persnr }}</td>
                <td>{{ user.fullName }}</td>
                <td class="text-left">
                  <div class="inline-block">
                    <input
                      type="checkbox"
                      v-model="user.superadmin"
                      :id="user.persnr + 'user_superadmin'"
                      @change="
                        sanitizePermissions(user, 'superadmin')
                      "
                    />
                    <label :for="user.persnr + 'user_superadmin'">Superadmin</label>
                  </div>
                  <br />
                  <div class="inline-block">
                    <input
                      type="checkbox"
                      v-model="user.admin"
                      :id="user.persnr + 'user_admin'"
                      @change="sanitizePermissions(user, 'admin')"
                    />
                    <label :for="user.persnr + 'user_admin'">Admin</label>
                  </div>
                  <br />
                  <div class="inline-block">
                    <input
                      type="checkbox"
                      v-model="user.standby"
                      :id="user.persnr + 'user_standby'"
                      @change="sanitizePermissions(user, 'standby')"
                    />
                    <label :for="user.persnr + 'user_standby'"
                      >Rufbereitschaft</label
                    >
                  </div>
                  <br />
                  <div class="inline-block">
                    <input
                      type="checkbox"
                      v-model="user.internalDispo"
                      :id="user.persnr + 'user_internalDispo'"
                      @change="
                        sanitizePermissions(user, 'internalDispo')
                      "
                    />
                    <label :for="user.persnr + 'user_internalDispo'"
                      >Interner Disponent</label
                    >
                  </div>
                  <br />
                  <div class="inline-block">
                    <input
                      type="checkbox"
                      v-model="user.externalDispo"
                      :id="user.persnr + 'user_externalDispo'"
                      @change="
                        sanitizePermissions(user, 'externalDispo')
                      "
                    />
                    <label :for="user.persnr + 'user_externalDispo'"
                      >Externer Disponent</label
                    >
                  </div>
                  <br />
                  <div class="inline-block">
                    <input
                      type="checkbox"
                      v-model="user.documents"
                      :id="user.persnr + 'user_documents'"
                      @change="
                        sanitizePermissions(user, 'documents')
                      "
                    />
                    <label :for="user.persnr + 'user_documents'"
                      >Schicht-Dokumente</label
                    >
                  </div>
                  <br />
                   <div class="inline-block">
                    <input
                      type="checkbox"
                      v-model="user.tours"
                      :id="user.persnr + 'user_tours'"
                      @change="
                        sanitizePermissions(user, 'tours')
                      "
                    />
                    <label :for="user.persnr + 'user_tours'"
                      >Rundgänge</label
                    >
                  </div>
                  <br />
                  <div class="inline-block">
                    <input
              type="checkbox"
              v-model="user.editEmployees"
              :id="user.persnr + 'user_editEmployees'"
              @change="
                sanitizePermissions(user, 'editEmployees')
              "
            />
            <label :for="user.persnr + 'user_editEmployees'">Mitarbeiterverwaltung</label>
            </div>
            <br />
            <div>
            <input
              type="checkbox"
              v-model="user.sensitiveDocuments"
              :id="user.persnr + 'user_sensitiveDocuments'"
              @change="
                sanitizePermissions(user, 'sensitiveDocuments')
              "
            />
            <label :for="user.persnr + 'user_sensitiveDocuments'">Vertrauliche Dokumente</label>
            </div>
                  </td>
                <td>
                  <div
                    v-if="user.internalDispo &&! user.admin"
                    class="inline-block p-2 relative align-top"
                  >
                    <span class="block font-bold mt-2">Projekt</span>
                    <input
                      v-model="user.project"
                      placeholder="Projektname"
                      @click="filterProjects(user)"
                      @focus="filterProjects(user)"
                      class="border-b-2 w-full sm:w-96 p-2 border-gray-500"
                      @input="filterProjects(user)"
                    />
                    <div
                      v-if="showProjectDropdown == user"
                      :ref="user.id + 'projectDropdown'"
                      class="z-10 border-gray-500 absolute p-2 w-full bg-white max-h-96 overflow-y-auto"
                    ></div>
                  </div>
                  <div
                    v-if="user.externalDispo &&! user.admin"
                    class="inline-block p-2 relative align-top"
                  >
                    <span class="block font-bold mt-2">Firma</span>
                    <input
                      v-model="user.ca"
                      placeholder="Firmenschlüssel"
                      @click="filterCAs(user)"
                      @focus="filterCAs(user)"
                      class="border-b-2 w-36 p-2 border-gray-500"
                      @input="filterCAs(user)"
                    />
                    <div
                      v-if="showCADropdown == user"
                      :ref="user.id + 'caDropdown'"
                      class="z-10 border-gray-500 absolute p-2 w-full bg-white max-h-96 overflow-y-auto"
                    ></div>
                  </div>
                </td>
                <td class="align-top">
                  <button
                    v-if="user.changed"
                    type="button"
                    class="mx-1 mt-4 admin-button--primary admin-button--sm"
                    @click="changeUser(user)"
                  >
                    Speichern
                  </button>
                  <button
                    v-if="user.changed"
                    type="button"
                    class="mx-1 mt-4 admin-button--secondary admin-button--sm"
                    @click="getUsers()"
                  >
                    Reset
                  </button>
                  <button
                    type="button"
                    class="mx-1 mt-4 admin-button--danger admin-button--sm"
                    @click="deleteUser(user)"
                  >
                    Löschen
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</template>

<script>
import CASP from "../../CASP";
import { useCookies } from "vue3-cookies";
import JobModal from "@/components/JobModal.vue";

export default {
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  name: "Jobs",
  components: { JobModal },
  data() {
    return {
      token: "",
      editedUser: {
        id: "",
        displayName: "",
        standby: false,
        internalDispo: false,
        externalDispo: false,
        admin: false,
        project: "",
        ca: "",
      },
      permissions: "",
      allProjects: [],
      allCAs: [],
      allUsers: [],
      showProjectDropdown: false,
      showUserDropdown: false,
      showCADropdown: false,
      selectedJob: false,
      adminusers: [],
    };
  },
  methods: {
    checkClick(event) {
      if (event.target.nodeName == "P") {
        if (this.showUserDropdown) {
          this.editedUser = this.allUsers.filter((el) => {
            return el.displayName == event.target.innerText;
          })[0];
          this.showUserDropdown = false;
        } else if (this.showProjectDropdown) {
          this.showProjectDropdown.project = event.target.innerText;
          this.showProjectDropdown.changed = true;
          this.showProjectDropdown = false;
        } else if (this.showCADropdown) {
          this.showCADropdown.ca = event.target.innerText;
          this.showCADropdown.changed = true;
          this.showCADropdown = false;
        }
      }
      if (event.target.nodeName != "INPUT") {
        this.showCADropdown = false;
        this.showUserDropdown = false;
        this.showProjectDropdown = false;
      } else if (event.target.placeholder == "Mitarbeiternr") {
        this.showProjectDropdown = false;
        this.showCADropdown = false;
      } else if (event.target.placeholder == "Firmenschlüssel") {
        this.showProjectDropdown = false;
        this.showUserDropdown = false;
      } else if (event.target.placeholder == "Projektname") {
        this.showCADropdown = false;
        this.showUserDropdown = false;
      } 
    },
    sanitizePermissions(user, field) {
      user.changed = true;
      if (user[field]) {
        if (field == "internalDispo" && user.externalDispo) {
          user.externalDispo = false;
        } else if (field == "externalDispo" && user.internalDispo) {
          user.internalDispo = false;
        } else if (field == "admin") {
          user.internalDispo = true;
          user.externalDispo = true;
          user.standby = true;
        }
      }else if(["internalDispo", "externalDispo", "standby"].includes(field)){
        user.admin=false
      }
    },
    setPermissions(user) {
      CASP.updateUser(
        this.token,
        user.id,
        { Mitarbeiternr: user.Mitarbeiternr.split(" (")[0] },
        (res) => {
          if (res) {
            delete user.MitarbeiternrChanged;
          }
        }
      );
    },
    getProjects() {
      let vm = this;
      CASP.getProjects(this.token, (res) => {
        if (res) {
          vm.allProjects = [{name: "Alle Projekte"}].concat(res);
        }
      });
    },
    getCAs() {
      let vm = this;
      CASP.getCAs(this.token, (res) => {
        if (res) {
          vm.allCAs = res;
        }
      });
    },
    getUsers() {
      let vm = this;
      CASP.getUsers(this.token, (res) => {
        if (res) {
          vm.allUsers = res;
        }
      });
    },
    deleteUser(user) {
      CASP.changeUser(this.token, user.id, {admin: false, internalDispo: false, externalDispo: false, standby: false}, (res) => {
        if (res) {
          this.getUsers();
        }
      });
    },
    changeUser(user) {
      CASP.changeUser(this.token, user.id, user, (res) => {
        if (res) {
          this.getUsers();
        }
      });
    },
    filterUsers(user) {
      this.showUserDropdown = user;
      let options = "";
      this.allUsers.forEach((el) => {
        if (
          el.displayName.toLowerCase().includes(user.displayName.toLowerCase())
        ) {
          options += "<p class='dp'>" + el.displayName + "</p>";
        }
      });
      if (this.$refs["userDropdown"]) {
        this.$refs["userDropdown"].innerHTML = options;
      }
    },
    filterProjects(user, edit) {
      this.showProjectDropdown = user;
      let options = "";
      this.allProjects.forEach((el) => {
        if (el.name.toLowerCase().includes(user.project.toLowerCase())) {
          options += "<p class='dp'>" + el.name + "</p>";
        }
      });
      let dropdownId = edit ? "" : user.id;
      let refElement = this.$refs[dropdownId + "projectDropdown"];
      if (refElement) {
        let element = Array.isArray(refElement) ? refElement[0] : refElement;
        if (element) {
          element.innerHTML = options;
        }
      }
    },
    filterCAs(user, edit) {
      this.showCADropdown = user;
      let options = "";
      this.allCAs.forEach((el) => {
        if (el.name.toLowerCase().includes(user.ca.toLowerCase())) {
          options += "<p class='dp'>" + el.name + "</p>";
        }
      });
      let dropdownId = edit ? "" : user.id;
      let refElement = this.$refs[dropdownId + "caDropdown"];
      if (refElement) {
        let element = Array.isArray(refElement) ? refElement[0] : refElement;
        if (element) {
          element.innerHTML = options;
        }
      }
    },
  },
  computed: {
    advancedUsers: function () {
      return this.allUsers.filter((el) => {
        return el.admin || el.internalDispo || el.externalDispo || el.standby;
      });
    },
  },
  created: function () {
    document.getElementById("mainspinner").style.display = "none";
      CASP.isAuthenticated("", (auth) => {
        if (!auth) {
          window.location = "/admin/login";
        } else {
          this.getProjects();
          this.getUsers();
          this.getCAs();
        }
      });
    
  },
};
</script>
<style scoped>
</style>